import request from 'utils/request';
import { DictionaryDto } from './dictionary';

export interface EndpointDto {
    id: string | number;
    code: string;
    name?: string;
    description?: string;
    request_method?: string;
    checked?: boolean;
}

export interface EndpointRoleDto {
    id?: number;
    endpoint: EndpointDto;
    user_role: DictionaryDto;
}

export function initEndpointRole(roleId: string, endpointId: string): EndpointRoleDto {
    return {
        endpoint: {
            id: endpointId,
            code: '',
        },
        user_role: {
            code: '',
            id: roleId,
            description: '',
            status: '',
        },
    };
}

export function createEndpointLink(roleId: string, endpointId: string): Promise<EndpointRoleDto> {
    return request({
        url: '/endpoint-role-link',
        method: 'post',
        params: {
            roleId,
            endpointId,
        },
    }).then(({ data }) => data as EndpointRoleDto);
}

export function removeEndpointLink(roleId: string, endpointId: string): Promise<any> {
    return request({
        url: `/endpoint-role-link?endpointId=${endpointId}&roleId=${roleId}`,
        method: 'delete',
    });
}
